<template>
    <div v-if="!isAuthorized" class="checkout-log-in">
        <svg class="checkout-log-in__icon"><use xlink:href="#svg-user"></use></svg>
        <span @click="handlerClick">
            {{ messages.orderNeedAuth }}
        </span>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: 'CheckoutLogIn',
    selector: '.checkout-log-in',
    props: ['result'],
    computed: {
        ...mapState({
            isAuthorized: ({ personal }) => personal.data?.authInfo?.isAuthorized,
            messages: ({ checkout }) => checkout.data?.vue?.messages,
        }),
    },
    methods: {
        handlerClick() {
            this.$DefModal.show({
                name: 'enter-cabinet',
                width: '440px',
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.checkout-log-in{
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: rem(14);
    line-height: 115%;
    cursor: pointer;
    &__icon{
        width: 16px;
        height: 16px;
        margin-right: 12px;
        flex-shrink: 0;
    }
}
</style>